@if (!configService.isAdmin()) {
  <spb-login [style.margin-top.rem]="12"/>
} @else {
  <div class="spb-content-holder">
    <div class="select">
      @if (helper.canShowClassic()) {
        <mat-card [routerLink]="['classic']">
          <mat-card-header>
            <ng-container>
              <div class="card-header" mat-card-avatar>
                <mat-icon>draw</mat-icon>
              </div>
              <mat-card-title class="header-title">
                Enkla lånelöftet
              </mat-card-title>
            </ng-container>
          </mat-card-header>
          <mat-card-content>
            Admin-system för digitala ansökningar samt vy över ansökningar inkl
            bifogade dokument.
          </mat-card-content>
        </mat-card>
      }
      @if (helper.canAdminRegistrar()) {
        <mat-card [routerLink]="['register']">
          <mat-card-header>
            <ng-container>
              <div class="card-header" mat-card-avatar>
                <mat-icon>work_history</mat-icon>
              </div>
              <mat-card-title class="header-title">
                Registrering och översikt
              </mat-card-title>
            </ng-container>
          </mat-card-header>
          <mat-card-content>
            Registrering av lånelöften och limiter som är beviljade i EKP samt
            översikt över samtliga beviljade lånelöften/limiter.
          </mat-card-content>
        </mat-card>
      }
    </div>
  </div>
}
